/*
  <skigrin-cart-timer> — "Din kurv er reserveret i MM:SS" in de cart drawer.

  De deadline staat in sessionStorage, dus de teller springt niet terug bij elke
  paginawissel of als Dawn de drawer opnieuw rendert. Hij start opnieuw zodra de
  sessie opnieuw begint of de teller afgelopen is.
*/
class SkigrinCartTimer extends HTMLElement {
  static storageKey = 'skigrin:cart-reserved-until';

  connectedCallback() {
    this.valueTarget = this.querySelector('[data-timer-value]');
    this.minutes = parseFloat(this.dataset.minutes) || 10;
    this.deadline = this.readDeadline();

    this.render();
    this.interval = setInterval(() => this.render(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  readDeadline() {
    let stored = null;
    try {
      stored = sessionStorage.getItem(SkigrinCartTimer.storageKey);
    } catch (error) {
      // Privémodus kan sessionStorage blokkeren; dan loopt de teller per pagina.
    }

    const parsed = stored ? parseInt(stored, 10) : NaN;
    if (!Number.isNaN(parsed) && parsed > Date.now()) return parsed;

    return this.startFresh();
  }

  startFresh() {
    const deadline = Date.now() + this.minutes * 60 * 1000;
    try {
      sessionStorage.setItem(SkigrinCartTimer.storageKey, String(deadline));
    } catch (error) {
      // Zie readDeadline.
    }
    return deadline;
  }

  render() {
    let remaining = Math.max(0, this.deadline - Date.now());

    if (remaining === 0) {
      this.deadline = this.startFresh();
      remaining = this.deadline - Date.now();
    }

    const total = Math.floor(remaining / 1000);
    const text = `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
    if (this.valueTarget && this.valueTarget.textContent !== text) this.valueTarget.textContent = text;
  }
}

if (!customElements.get('skigrin-cart-timer')) {
  customElements.define('skigrin-cart-timer', SkigrinCartTimer);
}
